// removed by extract-text-webpack-plugin
module.exports = {"raceCardContainer":"_328_WaHuZLSpDXDFPz048G","raceCardContent":"DSXg9Kd2RInPdcNbTVW5D","gameCardContainer":"_3HolM8qroe2H1qs2c6HFgy","bettingTypeToogleSlider":"_1L8gP1rLaIGd_Z-Wl3PHS4","selected":"uIJgpK93adldHhdl4sEc9","text":"_2Xo8XU3SxUpW8SK7axH1P1","arrowIconContainer":"_2TskSaMmL10hQVECyh3bH3","arrowIcon":"_3ywXtP6378tCT4dulnYpF1"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/desktop/modules/football/css/matchCard.css
// module id = 1053
// module chunks = 0